import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DndProvider } from 'react-dnd';

import { makeGetCurrentTeam, makeGetActiveTeamsAndLinkedTeamsCount } from '../selectors/teams';
import { makeGetSubscriptionIsExpired } from '../selectors/billing';

import { ModifiedBackend } from 'services/dnd-service';
import { isElectron, isMac } from 'services/env-service';

import { DocumentFocusProvider } from 'context/DocumentFocusContext';
import { LocaleProvider } from 'context/LocaleContext';
import { BrowserNotificationsProvider } from 'context/BrowserNotificationsContext';
import { NetworkConnectionProvider } from 'context/NetworkConnectionContext';
import { AlertProvider } from 'context/AlertContext';
import { UserStorageProvider } from 'context/UserStorageContext';
import { MeetingEmbedProvider } from 'context/MeetingEmbedContext';
import { ThemeProvider } from 'context/ThemeContext';
import { RolesAndPermissionsProvider } from 'context/RolesAndPermissionsContext';

import AppHead from './app-head';
import DesktopSidebar from 'components/DesktopSidebar';
import AppToasts from 'components/AppToasts';

class AppWrap extends PureComponent {
    isOnNonSubscriptionAllowed(loc) {
        return Boolean(loc.pathname === '/upgrade' || loc.pathname === '/dashboard' || loc.pathname === '/' || loc.pathname.match(/^\/settings\/(team|profile|notifications|apps)/));
    }

    toggleBlock() {
        if (this.unblock) {
            this.unblock();
        }

        if (this.props.isExpired) {
            if (!this.isOnNonSubscriptionAllowed(this.props.history.location)) {
                this.props.history.push({
                    pathname: '/dashboard'
                });
            }

            this.unblock = this.props.history.block(locaction => {
                return this.isOnNonSubscriptionAllowed(locaction);
            });
        } else {
            this.unblock && this.unblock();
        }
    }

    componentDidMount() {
        this.toggleBlock();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpired !== prevProps.isExpired) {
            this.toggleBlock();
        }
    }

    render() {
        const { localeDateFormat, localeTimeFormat, localeWeekStart, localeLanguage, ignoreWeekends, teamsCount, history, children } = this.props;
        const withSidebar = isElectron() && teamsCount > 1;

        return (
            <ThemeProvider>
                <AlertProvider>
                    <RolesAndPermissionsProvider>
                        <MeetingEmbedProvider>
                            <DndProvider backend={ModifiedBackend}>
                                <DocumentFocusProvider>
                                    <NetworkConnectionProvider>
                                            <BrowserNotificationsProvider>
                                                <UserStorageProvider>
                                                    <LocaleProvider>
                                                        <AppHead history={history} />

                                                        <div className={'app-wrap-inner' + (isElectron() ? ` is-electron ${isMac() ? 'is-electron-mac' : 'is-electron-win'}` : '') + (withSidebar ? ' with-desktop-sidebar' : ' without-desktop-sidebar')}>
                                                            {
                                                                withSidebar ? (
                                                                    <DesktopSidebar / >
                                                                ) : null
                                                            }

                                                            <div className="app">{ children }</div>

                                                            <AppToasts />
                                                        </div>
                                                    </LocaleProvider>
                                                </UserStorageProvider>
                                            </BrowserNotificationsProvider>
                                    </NetworkConnectionProvider>
                                </DocumentFocusProvider>
                            </DndProvider>
                        </MeetingEmbedProvider>
                    </RolesAndPermissionsProvider>
                </AlertProvider>
            </ThemeProvider>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();
    const getActiveTeamsAndLinkedTeamsCount = makeGetActiveTeamsAndLinkedTeamsCount();

    return ({ teams }) => {
        const currentTeam = teams && getCurrentTeam(teams);

        return {
            isExpired: currentTeam && getSubscriptionIsExpired(currentTeam),
            teamsCount: getActiveTeamsAndLinkedTeamsCount(teams.items, teams.linkedTeams)
        }
    };
};

export default connect(makeMapStateToProps)(AppWrap);

